export const functionId = {
  REFETCH_EVENTS: 'REFETCH_EVENTS',
  FETCH_ALL_ITEMS: 'FETCH_ALL_ITEMS',
  GET_FOCUSSESSION: 'GET_FOCUSSESSION',
}
